const industryList = require('@/utils/industryList')
const icons = {
  country: '/static/country.png',
  dealType: '/static/dealType.png',
  price: '/static/price.png',
  resultType: '/static/resultType.png',
  time: '/static/time.png',
  fbzt: '/static/fbzt.png',
  cpfl: '/static/cpfl.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '发布主体',
    prop: 'orgType',
    icon: icons.fbzt,
    tagList: [
      { name: '高校院所', value: '0', key: 'cn' },
      { name: '科研单位', value: '1', key: 'at' },
      { name: '国企单位', value: '2', key: 'guo' }
      // { name: '不限', value: '', key: '_infinity' }
    ]
  },
  {
    ...publicOptions,
    name: '产业分类',
    prop: 'industry',
    icon: icons.cpfl,
    tagList: industryList.industryLists
  },
  {
    ...publicOptions,
    name: '国家/地区',
    prop: 'publicationCountry',
    icon: icons.country,
    tagList: [
      { name: '中国', value: '中国', key: 'cn' },
      { name: '中国港澳台', value: '中国港澳台', key: 'at' },
      // { name: '中国澳门', value: '中国澳门', key: 'at' },
      { name: '美国', value: '美国', key: 'us' },
      { name: '英国', value: '英国', key: 'gb' },
      { name: '德国', value: '德国', key: 'de' },
      { name: '日本', value: '日本', key: 'jp' },
      { name: '其他地区', value: '其他地区', key: 'qt' }
      // { name: '不限', value: '不限', key: '_infinity' }
    ]
  },
  {
    ...publicOptions,
    name: '运营类型',
    icon: icons.dealType,
    prop: 'operationType',
    tagList: [
      { name: '许可', value: '1', key: 'operation0' },
      { name: '待转化', value: '0', key: 'operation1' },
      { name: '质押', value: '2', key: 'operation2' },
      { name: '转让', value: '3', key: 'operation3' }
      // { name: '不限', value: '不限', key: 'operationInfinity' }
    ]
  },
  {
    ...publicOptions,
    name: '成果类型',
    icon: icons.resultType,
    prop: 'patentType',
    tagList: [
      { name: '发明专利', value: '0', key: 'patent0' },
      { name: '实用新型', value: '1', key: 'patent1' },
      { name: '外观设计', value: '2', key: 'patent2' }
      // { name: '不限', value: '不限', key: 'patentInfinity' }
    ]
  },
  {
    ...publicOptions,
    name: '价格',
    icon: icons.price,
    prop: 'price',
    tagList: [
      // { name: '1万', value: '0-10000', key: '0-10000' },
      // { name: '1-2万', value: '10000-20000', key: '10000-20000' },
      // { name: '2-5万', value: '20000-50000', key: '20000-50000' },
      // { name: '5万以上', value: '50000', key: '50000' },
      { name: '面议', value: '-0', key: '-0' },
      {
        isCustom: true,
        typeName: 'LabelAndInput',
        name: '价格范围',
        initFunc() {
          this.maxV = null
          this.miniV = null
        },
        value: '',
        key: 'custom'
      }
    ]
  },
  {
    ...publicOptions,
    name: '发布时间',
    icon: icons.time,
    prop: 'searchValue',
    tagList: [
      { name: '今天', value: '1', key: 'day1' },
      { name: '三天内', value: '2', key: 'day2' },
      { name: '一周内', value: '3', key: 'day3' },
      { name: '一个月内', value: '4', key: 'day4' },
      { name: '三个月内', value: '5', key: 'day5' },
      { name: '一年内', value: '6', key: 'day6' }
      // { name: '不限', value: '0', key: 'day0' }
    ]
  }
]

const filterEmptyTagListItem = () => {
  return filterOptions.filter(i => i.tagList && i.tagList.length > 0)
}

module.exports = {
  filterOptions: filterEmptyTagListItem()
}
